module.exports = {"appName":"Program Ishrane","webDesign":"Web dizajn"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/translations/hr.json
// module id = I3NT
// module chunks = 0